import { render } from "./RouterErrorMessage.vue?vue&type=template&id=601afe54&scoped=true"
import script from "./RouterErrorMessage.vue?vue&type=script&lang=js"
export * from "./RouterErrorMessage.vue?vue&type=script&lang=js"

import "./RouterErrorMessage.vue?vue&type=style&index=0&id=601afe54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601afe54"]])

export default __exports__